export default {
    searchText: 'Search by Special Workday Name',
    search: 'Search',
    specialWorkdayName: 'Special Workday Name',
    createdDate: 'Date create',
    workDate: 'Work date',
    startEndTime: 'Start - End time',
    bureau: 'Bureau',
    action: '',
    addSpecialWorkday: 'Add Special workday',
    deleteHeader: 'Delete Special Workday',
    wantToDelete: 'Are you sure you want to delete',
    congratulation: 'Congratulation',
    deletedSpecialWorkday: 'Special Workday was deleted.'
}
